var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 7.5C14.25 7.5 13.3396 7.14844 12.6667 6.5625L7.56042 9.375C7.6 9.57031 7.6 9.80469 7.6 10C7.6 10.2344 7.6 10.4297 7.56042 10.625L12.6667 13.4375C13.3396 12.8516 14.25 12.5 15.2 12.5C17.2979 12.5 19 14.1797 19 16.25C19 18.3203 17.2979 20 15.2 20C13.1021 20 11.4 18.3203 11.4 16.25C11.4 16.0547 11.4 15.8203 11.4396 15.625L6.33333 12.8125C5.66042 13.3984 4.75 13.75 3.8 13.75C1.70208 13.75 0 12.0703 0 10C0 7.92969 1.70208 6.25 3.8 6.25C4.75 6.25 5.66042 6.60156 6.33333 7.1875L11.4396 4.375C11.4396 4.17969 11.4 3.94531 11.4 3.75C11.4 1.67969 13.1021 0 15.2 0C17.2979 0 19 1.67969 19 3.75C19 5.82031 17.2979 7.5 15.2 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlt);
export default __webpack_public_path__ + "static/media/share_alt.83df1cd288db2c4733bb6326768b0684.svg";
export { ForwardRef as ReactComponent };